require('angular').module('wowApp.common')
    .service('MemoScrollService', [require('./memoscroll-service')]);


/** WEBPACK FOOTER **
 ** ./wowapp/src/wowcommon/memoscroll/index.js
 **/